import React from "react";
import { Tooltip, Typography } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";

interface RenderDateWithPopupProps {
  inputDate: Date | string | null | undefined; // The due date
  paidDate?: Date | string | null | undefined; // The date the invoice was paid
}

const RenderDateWithPopup: React.FC<RenderDateWithPopupProps> = ({
  inputDate,
  paidDate,
}) => {
  const { t } = useTranslation();

  if (!inputDate || isNaN(new Date(inputDate).getTime())) {
    return <Typography variant="body2">{t("N/A")}</Typography>;
  }

  const dueDate = moment(inputDate, [moment.ISO_8601, "MM/DD/YYYY"]).endOf(
    "day",
  ); // Convert timestamp to Date object
  const formattedDueDate = moment(dueDate).format("MM/DD/YYYY");

  // Determine if the invoice is late or paid late
  const isLate = moment()
    .startOf("day")
    .isAfter(moment(dueDate).startOf("day"));
  const wasPaidLate =
    paidDate &&
    moment(paidDate).startOf("day").isAfter(moment(dueDate).startOf("day"));

  // Determine the tooltip text and display text
  let tooltipText = "";

  if (paidDate) {
    const formattedPaidDate = moment(paidDate).format("MM/DD/YYYY");
    if (wasPaidLate) {
      tooltipText = `${t("Paid late on")} ${formattedPaidDate}`;
    } else {
      tooltipText = `${t("Paid on time on")} ${formattedPaidDate}`;
    }
  } else if (isLate) {
    tooltipText = t("Due {{fromNow}}", { fromNow: moment(dueDate).fromNow() });
  } else {
    tooltipText = t("Due {{fromNow}}", { fromNow: moment(dueDate).fromNow() });
  }

  return (
    <Tooltip title={tooltipText}>
      <Typography variant="body2">{formattedDueDate}</Typography>
    </Tooltip>
  );
};

export default RenderDateWithPopup;
